<template>
  <div class="com">
    <div class="title">
      You're All Set!
    </div>
    <div class="subtitle">
      Your kit has been activated and submitted. You will receive updates on the
      status of your kit via the contact methods you selected.
    </div>
    <button class="btn" @click="goHome">Go to Dashboard</button>
  </div>
</template>

<script>
export default {
  name: "FinalStep",
  methods: {
    goHome() {
      if (this.$route.path != "/home") {
        this.$router.push("/home");
      } else {
        this.$emit("reRenderHome");
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.title {
  color: #005eb8;
  font-size: 27px;
  margin: 0 0 30px 0;
  text-align: center;
  font-family: TTNormsBold, sans-serif;
}
.subtitle {
  text-align: center;
  font-size: 16px;
  font-family: TTNormsRegular, sans-serif;
  width: 100%;
  margin: 0 auto 20px auto;
  line-height: 1.3;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: none;
  height: 45px;
  border-radius: 25px;
  max-width: 300px;
  transition: all 0.5s linear;
  font-size: 18px;
  font-family: TTNormsBold, sans-serif;
}
</style>
